var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14v14H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C85A7",
    d: "M9.667 2.1c0-.386-.299-.7-.667-.7H5c-.368 0-.667.314-.667.7v9.8c0 .386.299.7.667.7h4c.368 0 .667-.314.667-.7V2.1zM11 1.4v11.2c0 .774-.597 1.4-1.333 1.4H4.333C3.597 14 3 13.373 3 12.6V1.4C3 .627 3.597 0 4.333 0h5.334C10.403 0 11 .626 11 1.4zm-3 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon_phone.2096093ee03ba1654a3949f8ace2dde5.svg";
export { ForwardRef as ReactComponent };